export default __webpack_public_path__ + "static/media/pages.53aea58a.svg";